import {
    ACTIVE_INTERACTIVE_VIDEOS_FETCH_ERROR,
    ACTIVE_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    ACTIVE_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
    ADD_INTERACTION_SET,
    ASSET_INFO_VIDEO_DESCRIPTION_SET,
    ASSET_INFO_VIDEO_SOURCE_FILE_SET,
    ASSET_INFO_VIDEO_TITLE_SET,
    EDIT_INTERACTION_CARD_HIDE,
    EDIT_INTERACTION_CARD_SHOW,
    INTERACTIVE_SEARCH_VALUE_SET,
    INTERACTIVE_TABS_VALUE_SET,
    INTERACTIVE_VIDEOS_FETCH_ERROR,
    INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    INTERACTIVE_VIDEOS_FETCH_SUCCESS,
    IV_CHANNEL_TAB_VALUE_SET,
    MY_INTERACTIVE_VIDEOS_FETCH_ERROR,
    MY_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    MY_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
    PUBLISH_BLOCK_LIST_ACCOUNTS_SET,
    PUBLISH_DIALOG_HIDE,
    PUBLISH_DIALOG_SHOW,
    PUBLISH_ELIGIBLE_COLLECTIONS_SET,
    PUBLISH_SCHEDULE_START_TIME_SET,
    PUBLISH_SCHEDULE_TAB_SET,
    PUBLISH_VISIBILITY_TAB_SET,
    PUBLISH_WHITELIST_SET,
    PUBLISH_WHITELIST_UNSET,
    SELECTED_COLLECTION_SET,
    TOKEN_PROTECTED_SWITCH_SET,
    UPCOMING_INTERACTIVE_VIDEOS_FETCH_ERROR,
    UPCOMING_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    UPCOMING_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
    FETCH_GATED_INTERACTIONS_IN_PROGRESS,
    FETCH_GATED_INTERACTIONS_SUCCESS,
    FETCH_GATED_INTERACTIONS_ERROR,
    FETCH_VIDEO_MINTS_IN_PROGRESS,
    FETCH_VIDEO_MINTS_SUCCESS,
    FETCH_VIDEO_MINTS_ERROR,
    FETCH_PUBLISHED_VIDEOS_IN_PROGRESS,
    FETCH_PUBLISHED_VIDEOS_SUCCESS,
    FETCH_PUBLISHED_VIDEOS_ERROR,
    PARTICIPATION_NFTS_LIST_IN_PROGRESS,
    PARTICIPATION_NFTS_LIST_SUCCESS,
    PARTICIPATION_NFTS_LIST_ERROR,
    TOKEN_PROTECTED_TYPE_SWITCH_SET,
    VOD_INTERACTIVE_VIDEOS_FETCH_ERROR,
    VOD_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
    VOD_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    FETCH_IV_STATS_IN_PROGRESS,
    FETCH_IV_STATS_SUCCESS,
    FETCH_IV_STATS_ERROR,
    GATED_UNTIL_VALUE_SET,
    FETCH_NETWORKS_SUCCESS,
    FETCH_NETWORKS_IN_PROGRESS,
    FETCH_NETWORKS_ERROR,
    SELECTED_NETWORK_SET,
    FETCH_PROPOSALS_SUCCESS,
    FETCH_PROPOSALS_IN_PROGRESS,
    FETCH_PROPOSALS_ERROR,
    SELECTED_PROPOSAL_SET,
    FETCH_NETWORK_DETAILS_IN_PROGRESS,
    FETCH_NETWORK_DETAILS_SUCCESS,
    FETCH_NETWORK_DETAILS_ERROR,
    FETCH_PROPOSAL_DETAILS_IN_PROGRESS,
    FETCH_PROPOSAL_DETAILS_SUCCESS,
    FETCH_PROPOSAL_DETAILS_ERROR,
    STAKING_AMOUNT_VALUE_SET,
    SELECTED_VALIDATOR_VALUE_SET,
    FETCH_VALIDATORS_ERROR,
    FETCH_VALIDATORS_SUCCESS,
    FETCH_VALIDATORS_IN_PROGRESS,
    MIN_DELEGATION_AMOUNT_SET,
    APR_FETCH_IN_PROGRESS,
    APR_FETCH_SUCCESS,
    APR_FETCH_ERROR,
    NETWORK_BALANCE_FETCH_IN_PROGRESS,
    NETWORK_BALANCE_FETCH_SUCCESS,
    NETWORK_BALANCE_FETCH_ERROR,
    FETCH_STAKING_DETAILS_ERROR,
    FETCH_STAKING_DETAILS_IN_PROGRESS,
    FETCH_STAKING_DETAILS_SUCCESS,
    ASSET_SUBTITLES_SET,
    GATED_TYPE_SET,
    STAKING_PREFERENCE_DIALOG_HIDE,
    STAKING_PREFERENCE_DIALOG_SHOW,
    STAKING_PREFERENCE_SET,
    DELETE_STAKING_PREFERENCE_DIALOG_HIDE,
    DELETE_STAKING_PREFERENCE_DIALOG_SHOW,
    VALIDATOR_IMAGE_FETCH_IN_PROGRESS,
    VALIDATOR_IMAGE_FETCH_SUCCESS,
    VALIDATOR_IMAGE_FETCH_ERROR,
    DYNAMIC_NETWORK_SELECT_FIELD_SET,
    DYNAMIC_NETWORK_SELECT_SWITCH_SET,
    SELECT_POLL_TYPE_TAB_SET,
} from '../../constants/interactiveVideos';
import {
    urlFetchInteractiveVideos,
    urlFetchMyInteractiveVideos,
    urlFetchVODInteractiveVideos,
    urlParticipationNftsList,
    urlTokenProtectedVideos,
    urlVideoMints,
} from '../../constants/restURL';
import Axios from 'axios';
import { handleErrorMessage } from '../../utils/errorMessages';
import {
    IV_STATS_URL,
    NETWORKS_URL,
    urlProposalsList,
    urlFetchProposalDetails,
    urlFetchNetworkDetails,
    urlValidatorsList,
    urlfetchNetworkBalance,
    urlFetchStakingDetails,
    validatorImageURL,
} from '../../constants/url';
import { calculateNominalAPR, calculateRealAPR, getBlocksPerYearReal, getParams } from '../../utils/aprCalculation';

export const setIVChannelTabValue = (value) => {
    return {
        type: IV_CHANNEL_TAB_VALUE_SET,
        value,
    };
};

export const showEditInteractionCard = (value, index) => {
    return {
        type: EDIT_INTERACTION_CARD_SHOW,
        value,
        index,
    };
};

export const hideEditInteractionCard = () => {
    return {
        type: EDIT_INTERACTION_CARD_HIDE,
    };
};

export const setAddInteraction = (value) => {
    return {
        type: ADD_INTERACTION_SET,
        value,
    };
};

export const setInteractiveTab = (value) => {
    return {
        type: INTERACTIVE_TABS_VALUE_SET,
        value,
    };
};

export const setInteractiveSearch = (value) => {
    return {
        type: INTERACTIVE_SEARCH_VALUE_SET,
        value,
    };
};

export const setPublishScheduleStartTime = (value, valid) => {
    return {
        type: PUBLISH_SCHEDULE_START_TIME_SET,
        value,
        valid,
    };
};

export const setPublishVisibilityTab = (value) => {
    return {
        type: PUBLISH_VISIBILITY_TAB_SET,
        value,
    };
};

export const setPublishScheduleTab = (value) => {
    return {
        type: PUBLISH_SCHEDULE_TAB_SET,
        value,
    };
};

export const setDynamicNetworkSelectSwitch = (value) => {
    return {
        type: DYNAMIC_NETWORK_SELECT_SWITCH_SET,
        value,
    };
};

export const setDynamicNetworkSelectField = (value) => {
    return {
        type: DYNAMIC_NETWORK_SELECT_FIELD_SET,
        value,
    };
};

export const setTokenProtectedSwitch = (value) => {
    return {
        type: TOKEN_PROTECTED_SWITCH_SET,
        value,
    };
};

export const setTokenProtectedTypeSwitch = (value) => {
    return {
        type: TOKEN_PROTECTED_TYPE_SWITCH_SET,
        value,
    };
};

export const setPublishWhiteList = (value) => {
    return {
        type: PUBLISH_WHITELIST_SET,
        value,
    };
};

export const clearPublishWhiteList = () => {
    return {
        type: PUBLISH_WHITELIST_UNSET,
    };
};

export const setGatedUntilValue = (value) => {
    return {
        type: GATED_UNTIL_VALUE_SET,
        value,
    };
};

export const setPublishEligibleCollections = (value, valid) => {
    return {
        type: PUBLISH_ELIGIBLE_COLLECTIONS_SET,
        value,
        valid,
    };
};

export const setPublishBlackListAccounts = (value) => {
    return {
        type: PUBLISH_BLOCK_LIST_ACCOUNTS_SET,
        value,
    };
};

// asset info
export const setAssetInfoVideoTitle = (value, valid) => {
    return {
        type: ASSET_INFO_VIDEO_TITLE_SET,
        value,
        valid,
    };
};

export const setAssetInfoVideoDescription = (value, valid) => {
    return {
        type: ASSET_INFO_VIDEO_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setAssetInfoVideoSourceFile = (value, valid, type) => {
    return {
        type: ASSET_INFO_VIDEO_SOURCE_FILE_SET,
        value,
        valid,
        typp: type,
    };
};

export const setAssetSubtitles = (value, valid, type) => {
    return {
        type: ASSET_SUBTITLES_SET,
        value,
        valid,
        typp: type,
    };
};

const fetchIvStatsInProgress = () => {
    return {
        type: FETCH_IV_STATS_IN_PROGRESS,
    };
};

const fetchIvStatsSuccess = (value) => {
    return {
        type: FETCH_IV_STATS_SUCCESS,
        value,
    };
};

const fetchIvStatsError = (message) => {
    return {
        type: FETCH_IV_STATS_ERROR,
        message,
    };
};

export const fetchIvStats = () => (dispatch) => {
    dispatch(fetchIvStatsInProgress());

    Axios.get(IV_STATS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchIvStatsSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchIvStatsError(message));
        });
};

const fetchMyInteractiveVideosInProgress = () => {
    return {
        type: MY_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    };
};

const fetchMyInteractiveVideosSuccess = (value, skip, limit, search, total) => {
    return {
        type: MY_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchMyInteractiveVideosError = (message) => {
    return {
        type: MY_INTERACTIVE_VIDEOS_FETCH_ERROR,
        message,
    };
};

export const fetchMyInteractiveVideos = (address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchMyInteractiveVideosInProgress());

    const url = urlFetchMyInteractiveVideos(address, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchMyInteractiveVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMyInteractiveVideosError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchInteractiveVideosInProgress = () => {
    return {
        type: INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    };
};

const fetchInteractiveVideosSuccess = (value, skip, limit, search, total) => {
    return {
        type: INTERACTIVE_VIDEOS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchInteractiveVideosError = (message) => {
    return {
        type: INTERACTIVE_VIDEOS_FETCH_ERROR,
        message,
    };
};

export const fetchInteractiveVideos = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchInteractiveVideosInProgress());

    const url = urlFetchInteractiveVideos(skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchInteractiveVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchInteractiveVideosError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchVODInteractiveVideosInProgress = () => {
    return {
        type: VOD_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    };
};

const fetchVODInteractiveVideosSuccess = (value, skip, limit, search, total) => {
    return {
        type: VOD_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchVODInteractiveVideosError = (message) => {
    return {
        type: VOD_INTERACTIVE_VIDEOS_FETCH_ERROR,
        message,
    };
};

export const fetchVODInteractiveVideos = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchVODInteractiveVideosInProgress());

    const url = urlFetchVODInteractiveVideos(skip, limit, search, '', '', 'vod');
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchVODInteractiveVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchVODInteractiveVideosError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchActiveInteractiveVideosInProgress = () => {
    return {
        type: ACTIVE_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    };
};

const fetchActiveInteractiveVideosSuccess = (value, skip, limit, search, total) => {
    return {
        type: ACTIVE_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchActiveInteractiveVideosError = (message) => {
    return {
        type: ACTIVE_INTERACTIVE_VIDEOS_FETCH_ERROR,
        message,
    };
};

export const fetchActiveInteractiveVideos = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchActiveInteractiveVideosInProgress());

    const url = urlFetchInteractiveVideos(skip, limit, search, 'active');
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchActiveInteractiveVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchActiveInteractiveVideosError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchUpcomingInteractiveVideosInProgress = () => {
    return {
        type: UPCOMING_INTERACTIVE_VIDEOS_FETCH_IN_PROGRESS,
    };
};

const fetchUpcomingInteractiveVideosSuccess = (value, skip, limit, search, total) => {
    return {
        type: UPCOMING_INTERACTIVE_VIDEOS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchUpcomingInteractiveVideosError = (message) => {
    return {
        type: UPCOMING_INTERACTIVE_VIDEOS_FETCH_ERROR,
        message,
    };
};

export const fetchUpcomingInteractiveVideos = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchUpcomingInteractiveVideosInProgress());

    const url = urlFetchInteractiveVideos(skip, limit, search, 'upcoming');
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchUpcomingInteractiveVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchUpcomingInteractiveVideosError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const showPublishDialog = () => {
    return {
        type: PUBLISH_DIALOG_SHOW,
    };
};

export const hidePublishDialog = () => {
    return {
        type: PUBLISH_DIALOG_HIDE,
    };
};

export const selectedCollection = (value) => {
    return {
        type: SELECTED_COLLECTION_SET,
        value,
    };
};

const fetchGatedInteractionsInProgress = () => {
    return {
        type: FETCH_GATED_INTERACTIONS_IN_PROGRESS,
    };
};

const fetchPublishedVideosInProgress = () => {
    return {
        type: FETCH_PUBLISHED_VIDEOS_IN_PROGRESS,
    };
};

const fetchPublishedVideosSuccess = (value, skip, limit, search, status, publishStatuses, total) => {
    return {
        type: FETCH_PUBLISHED_VIDEOS_SUCCESS,
        value,
        skip,
        limit,
        search,
        status,
        publishStatuses,
        total,
    };
};

const fetchPublishedVideosError = (message) => {
    return {
        type: FETCH_PUBLISHED_VIDEOS_ERROR,
        message,
    };
};

export const fetchPublishedVideos = (skip, limit, search, status, publishStatuses, cb) => (dispatch) => {
    dispatch(fetchPublishedVideosInProgress());

    const url = urlFetchInteractiveVideos(skip, limit, search, status, publishStatuses);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchPublishedVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, status, publishStatuses, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchPublishedVideosError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchGatedInteractionsSuccess = (value, skip, limit, total, search) => {
    return {
        type: FETCH_GATED_INTERACTIONS_SUCCESS,
        value,
        skip,
        limit,
        total,
        search,
        variant: 'success',
    };
};

const fetchGatedInteractionsError = (message) => {
    return {
        type: FETCH_GATED_INTERACTIONS_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchGatedInteractions = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchGatedInteractionsInProgress());

    const url = urlTokenProtectedVideos(skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchGatedInteractionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count, search));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchGatedInteractionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchVideoMintsInProgress = () => {
    return {
        type: FETCH_VIDEO_MINTS_IN_PROGRESS,
    };
};

const fetchVideoMintsSuccess = (value, skip, limit, total, search) => {
    return {
        type: FETCH_VIDEO_MINTS_SUCCESS,
        value,
        skip,
        limit,
        total,
        search,
        variant: 'success',
    };
};

const fetchVideoMintsError = (message) => {
    return {
        type: FETCH_VIDEO_MINTS_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchVideoMints = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchVideoMintsInProgress());

    const url = urlVideoMints(skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchVideoMintsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count, search));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchVideoMintsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchPartcipationNftsListInProgress = () => {
    return {
        type: PARTICIPATION_NFTS_LIST_IN_PROGRESS,
    };
};

const fetchPartcipationNftsListSuccess = (value, skip, limit, total, search) => {
    return {
        type: PARTICIPATION_NFTS_LIST_SUCCESS,
        value,
        skip,
        limit,
        total,
        search,
        variant: 'success',
    };
};

const fetchPartcipationNftsListError = (message) => {
    return {
        type: PARTICIPATION_NFTS_LIST_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchPartcipationNftsList = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchPartcipationNftsListInProgress());

    const url = urlParticipationNftsList(skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchPartcipationNftsListSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count, search));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchPartcipationNftsListError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNetworksInProgress = () => {
    return {
        type: FETCH_NETWORKS_IN_PROGRESS,
    };
};

const fetchNetworksError = (message) => {
    return {
        type: FETCH_NETWORKS_ERROR,
        message,
        variant: 'error',
    };
};

const fetchNetworksSuccess = (value) => {
    return {
        type: FETCH_NETWORKS_SUCCESS,
        value,
        variant: 'success',
    };
};

export const fetchNetworks = (cb) => (dispatch) => {
    dispatch(fetchNetworksInProgress());

    Axios.get(NETWORKS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchNetworksSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNetworksError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNetworkDetailsInProgress = () => {
    return {
        type: FETCH_NETWORK_DETAILS_IN_PROGRESS,
    };
};

const fetchNetworkDetailsError = (message) => {
    return {
        type: FETCH_NETWORK_DETAILS_ERROR,
        message,
        variant: 'error',
    };
};

const fetchNetworkDetailsSuccess = (value) => {
    return {
        type: FETCH_NETWORK_DETAILS_SUCCESS,
        value,
        variant: 'success',
    };
};

export const fetchNetworkDetails = (id, cb) => (dispatch) => {
    dispatch(fetchNetworkDetailsInProgress());

    const url = urlFetchNetworkDetails(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchNetworkDetailsSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNetworkDetailsError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const setSelectedNetwork = (value) => {
    return {
        type: SELECTED_NETWORK_SET,
        value,
    };
};

const fetchProposalsInProgress = () => {
    return {
        type: FETCH_PROPOSALS_IN_PROGRESS,
    };
};

const fetchProposalsSuccess = (value) => {
    return {
        type: FETCH_PROPOSALS_SUCCESS,
        value,
    };
};

const fetchProposalsError = (message) => {
    return {
        type: FETCH_PROPOSALS_ERROR,
        message,
    };
};

export const fetchProposals = (restUrl, cb) => (dispatch) => {
    dispatch(fetchProposalsInProgress());

    Axios.get(urlProposalsList(restUrl), {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchProposalsSuccess(res.data && res.data.proposals));
            if (cb) {
                cb(res.data && res.data.proposals);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchProposalsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchProposalDetailsInProgress = () => {
    return {
        type: FETCH_PROPOSAL_DETAILS_IN_PROGRESS,
    };
};

const fetchProposalDetailsSuccess = (value) => {
    return {
        type: FETCH_PROPOSAL_DETAILS_SUCCESS,
        value,
    };
};

const fetchProposalDetailsError = (message) => {
    return {
        type: FETCH_PROPOSAL_DETAILS_ERROR,
        message,
    };
};

export const fetchProposalDetails = (restUrl, id, cb) => (dispatch) => {
    dispatch(fetchProposalDetailsInProgress());

    const url = urlFetchProposalDetails(restUrl, id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchProposalDetailsSuccess(res.data && res.data.proposal));
            if (cb) {
                cb(res.data && res.data.proposal);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchProposalDetailsError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const setSelectedProposal = (value) => {
    return {
        type: SELECTED_PROPOSAL_SET,
        value,
    };
};

export const setStakeAmountValue = (value) => {
    return {
        type: STAKING_AMOUNT_VALUE_SET,
        value,
    };
};

export const setMinDelegationAmount = (value) => {
    return {
        type: MIN_DELEGATION_AMOUNT_SET,
        value,
    };
};

export const setSelectedValidatorValue = (value) => {
    return {
        type: SELECTED_VALIDATOR_VALUE_SET,
        value,
    };
};

const fetchValidatorsInProgress = () => {
    return {
        type: FETCH_VALIDATORS_IN_PROGRESS,
    };
};

const fetchValidatorsSuccess = (value) => {
    return {
        type: FETCH_VALIDATORS_SUCCESS,
        value,
    };
};

const fetchValidatorsError = (message) => {
    return {
        type: FETCH_VALIDATORS_ERROR,
        message,
    };
};

export const fetchValidators = (restUrl, cb) => (dispatch) => {
    dispatch(fetchValidatorsInProgress());

    Axios.get(urlValidatorsList(restUrl), {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchValidatorsSuccess(res.data && res.data.validators));
            if (cb) {
                cb(res.data && res.data.validators);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchValidatorsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchValidatorImageInProgress = () => {
    return {
        type: VALIDATOR_IMAGE_FETCH_IN_PROGRESS,
    };
};

export const fetchValidatorImageSuccess = (value) => {
    return {
        type: VALIDATOR_IMAGE_FETCH_SUCCESS,
        value,
    };
};

const fetchValidatorImageError = (message) => {
    return {
        type: VALIDATOR_IMAGE_FETCH_ERROR,
        message,
    };
};

export const fetchValidatorImage = (prefix, id) => (dispatch) => {
    dispatch(fetchValidatorImageInProgress());
    const URL = validatorImageURL(id);
    return Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            let obj = sessionStorage.getItem(`${prefix}_images`) || '{}';
            obj = obj && JSON.parse(obj);
            obj[id] = res.data;
            obj = obj && JSON.stringify(obj);
            sessionStorage.setItem(`${prefix}_images`, obj);
            dispatch(fetchValidatorImageSuccess({
                ...res.data,
                _id: id,
            }));
        })
        .catch((error) => {
            dispatch(fetchValidatorImageError(
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : 'Failed!',
            ));
        });
};

const fetchAPRInProgress = () => {
    return {
        type: APR_FETCH_IN_PROGRESS,
    };
};

export const fetchAPRSuccess = (nominalAPR, actualAPR) => {
    return {
        type: APR_FETCH_SUCCESS,
        nominalAPR,
        actualAPR,
    };
};

const fetchAPRError = (message) => {
    return {
        type: APR_FETCH_ERROR,
        message,
    };
};

export const fetchAPR = (apiUrl) => (dispatch) => {
    dispatch(fetchAPRInProgress());
    (async () => {
        try {
            const lcdApi = Axios.create({
                baseURL: apiUrl,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Accept: 'application/json',
                },
            });

            const params = await getParams(lcdApi);
            const blocksYearReal = await getBlocksPerYearReal(lcdApi);
            const nominalAPR = calculateNominalAPR(params);
            const actualAPR = calculateRealAPR(params, nominalAPR, blocksYearReal);

            dispatch(fetchAPRSuccess((nominalAPR * 100), (actualAPR * 100)));
        } catch (error) {
            dispatch(fetchAPRError(
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : error,
            ));
            return null;
        }
    })();
};

const fetchNetworkBalanceInProgress = () => {
    return {
        type: NETWORK_BALANCE_FETCH_IN_PROGRESS,
    };
};

const fetchNetworkBalanceSuccess = (value, address) => {
    return {
        type: NETWORK_BALANCE_FETCH_SUCCESS,
        value,
        address,
    };
};

const fetchNetworkBalanceError = (message) => {
    return {
        type: NETWORK_BALANCE_FETCH_ERROR,
        message,
    };
};

export const getBalance = (restUrl, address) => (dispatch) => {
    dispatch(fetchNetworkBalanceInProgress());
    const url = urlfetchNetworkBalance(restUrl, address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNetworkBalanceSuccess(res.data && res.data.balances, address));
        })
        .catch((error) => {
            dispatch(fetchNetworkBalanceError(
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : 'Failed!',
            ));
        });
};

const fetchStakingDetailsInProgress = () => {
    return {
        type: FETCH_STAKING_DETAILS_IN_PROGRESS,
    };
};

export const fetchStakingDetailsSuccess = (value) => {
    return {
        type: FETCH_STAKING_DETAILS_SUCCESS,
        value,
    };
};

const fetchStakingDetailsError = (message) => {
    return {
        type: FETCH_STAKING_DETAILS_ERROR,
        message,
    };
};

export const fetchStakingDetails = (restUrl, cb) => (dispatch) => {
    dispatch(fetchStakingDetailsInProgress());

    const url = urlFetchStakingDetails(restUrl);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchStakingDetailsSuccess(res.data && res.data.params));
            if (cb) {
                cb(res.data && res.data.params);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchStakingDetailsError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const setGatedType = (value) => {
    return {
        type: GATED_TYPE_SET,
        value,
    };
};

export const showStakingPreferenceDialog = (value) => {
    return {
        type: STAKING_PREFERENCE_DIALOG_SHOW,
        value,
    };
};

export const hideStakingPreferenceDialog = () => {
    return {
        type: STAKING_PREFERENCE_DIALOG_HIDE,
    };
};

export const setStakingPreference = (value) => {
    return {
        type: STAKING_PREFERENCE_SET,
        value,
    };
};

export const showDeleteStakingPreferenceDialog = (value) => {
    return {
        type: DELETE_STAKING_PREFERENCE_DIALOG_SHOW,
        value,
    };
};

export const hideDeleteStakingPreferenceDialog = () => {
    return {
        type: DELETE_STAKING_PREFERENCE_DIALOG_HIDE,
    };
};

export const setPollTypeTab = (value) => {
    return {
        type: SELECT_POLL_TYPE_TAB_SET,
        value,
    };
};
